import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  isDark = true;

  constructor() {
    this.initTheme();
  }

  private initTheme() {
    // Check for system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    this.isDark = prefersDark.matches;
    this.applyTheme();

    // Listen for changes
    prefersDark.addEventListener('change', (e) => {
      this.isDark = e.matches;
      this.applyTheme();
    });
  }

  toggleTheme() {
    // Still allow manual override if needed, but the user requested system sync
    this.isDark = !this.isDark;
    this.applyTheme();
  }

  private applyTheme() {
    if (this.isDark) {
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
  }
}
